import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
const css = `
.bottom-sheet-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 999;
    animation: bsFade 0.18s ease-out;
}

.bottom-sheet {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    max-height: 70dvh;
    background: #fff;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.18);
    z-index: 1000;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    animation: bsSlideUp 0.22s ease-out;
}

.bottom-sheet-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px 8px;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
}

.bottom-sheet-title {
    font-size: 12px;
    font-weight: 700;
    color: #a0aec0;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.bottom-sheet-close {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
    color: #718096;
    padding: 4px 8px;
    line-height: 1;
}

.bottom-sheet-body {
    padding: 0 16px 16px;
}

@media (min-width: 768px) {
    .bottom-sheet {
        left: 50%;
        right: auto;
        bottom: 80px;
        transform: translateX(-50%);
        width: 420px;
        max-width: calc(100% - 32px);
        max-height: 70vh;
        border-radius: 14px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
        animation: bsSlideUpDesktop 0.22s ease-out;
    }
    .bottom-sheet-backdrop {
        background: rgba(0, 0, 0, 0.2);
    }
}

@keyframes bsFade {
    from { opacity: 0 }
    to   { opacity: 1 }
}
@keyframes bsSlideUp {
    from { transform: translateY(100%) }
    to   { transform: translateY(0) }
}
@keyframes bsSlideUpDesktop {
    from { transform: translate(-50%, 20px); opacity: 0 }
    to   { transform: translate(-50%, 0);    opacity: 1 }
}
`;
export function BottomSheet({ open, onClose, title, children }) {
    useEffect(() => {
        if (!open)
            return;
        // блокируем скролл body, пока шторка открыта
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = prev; };
    }, [open]);
    if (!open)
        return null;
    return createPortal(_jsxs(_Fragment, { children: [_jsx("style", { children: css }), _jsx("div", { className: "bottom-sheet-backdrop", onClick: onClose }), _jsxs("div", { className: "bottom-sheet", onClick: e => e.stopPropagation(), children: [title && (_jsxs("div", { className: "bottom-sheet-header", children: [_jsx("span", { className: "bottom-sheet-title", children: title }), _jsx("button", { className: "bottom-sheet-close", onClick: onClose, children: "\u2715" })] })), _jsx("div", { className: "bottom-sheet-body", children: children })] })] }), document.body);
}
